export enum GAM_FLAG {
  ENABLED = '1',
  DISABLED = '0',
}
